<template>
  <div id="four-card">
    <div class="four-card">
      <el-row :gutter="20">
        <el-col :span="6"
          ><div class="card-item">
            <p class="item-icon iconfont">&#xe6d5;</p>
            <p class="item-number">{{ this.$t("lang.Home.thirty") }}</p>
            <p class="item-content">
              {{ this.$t("lang.Home.nationalRegion") }}
            </p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="card-item">
            <p class="item-icon iconfont">&#xe608;</p>
            <p class="item-number">{{ this.$t("lang.Home.tenThousand") }}</p>
            <p class="item-content">
              {{ this.$t("lang.Home.medicalInstitution") }}
            </p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="card-item">
            <p class="item-icon iconfont">&#xe60d;</p>
            <p class="item-number">
              {{ this.$t("lang.Home.oneThousandSeven") }}
            </p>
            <p class="item-content">
              {{ this.$t("lang.Home.domesticHospital") }}
            </p>
          </div></el-col
        >
        <el-col :span="6"
          ><div class="card-item">
            <p class="item-icon iconfont">&#xe60e;</p>
            <p class="item-number">{{ this.$t("lang.Home.threeThousand") }}</p>
            <p class="item-content">
              {{ this.$t("lang.Home.medicalExperts") }}
            </p>
          </div></el-col
        >
      </el-row>
      <home-title :content="text" style="width: 100%"></home-title>
    </div>
  </div>
</template>

<script>
import HomeTitle from "../home/HomeTitle";
export default {
  name: "FourCard",
  components: {
    HomeTitle
  },
  data() {
    return {
      text: { Chinese: "我们的服务", English: "Our Services" }
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/global";
#four-card {
  width: 100%;
  height: 560px;
  background: url("../../assets/images/feiji.png");
  background-size: 100% 100%;
  overflow: hidden;
  .four-card {
    width: 75%;
    margin: 100px auto;
    .card-item {
      text-align: center;
      height: 260px;
      background: #ffffff;
      box-shadow: 0 8px 8px 1px rgba(172, 214, 255, 0.22);
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #3490ec;
      margin-bottom: 100px;
      border-radius: 8px;
      .item-icon {
        font-size: 70px;
      }
      .item-number {
        font-size: 28px;
        margin-top: 10px;
      }
      .item-content {
        font-size: 20px;
        height: 20px;
        margin: 10px 5px;
      }
    }
  }
}
</style>
